'use client'
import {
  THEME_QUERY
} from "./chunk-X74FHHFA.mjs";
import {
  CARD_QUERY
} from "./chunk-ZJBMFTE6.mjs";
import {
  TAG_QUERY
} from "./chunk-MWW3YBFP.mjs";
import {
  getProductCardQuery
} from "./chunk-QPUNJKQ3.mjs";
import {
  SCHEDULE_QUERY
} from "./chunk-5GNKV3HD.mjs";
import {
  LOCATION_QUERY
} from "./chunk-4R6INYD4.mjs";
import {
  LINK_QUERY
} from "./chunk-Y5YNZ765.mjs";
import {
  IMAGE_QUERY
} from "./chunk-AFUSNP5S.mjs";

// src/api/queries/webSection.ts
var getWebSectionQuery = ({
  contentLimit = 30,
  contentSkip = 0
} = {}) => `
    id
    title
    subtitle
    collapsableDescription{json}
    renderType
    itemRenderType
    backgroundColor
    topPadding
    bottomPadding
    sectionBackground {${IMAGE_QUERY}}
    logo {${IMAGE_QUERY}}
    topDecorator {${IMAGE_QUERY}}
    bottomDecorator {${IMAGE_QUERY}}
    platform
    organizationSlug
    teamId
    webLinksCollection(limit: 6){
        items{${LINK_QUERY}}
    }
    theme { ${THEME_QUERY} }
    experimentConfig {
        experimentKey
        variantsCollection(limit: 3){
            items{ key section{ id } }
        }
    }
    tagsCollection(limit: 10){
        items {${TAG_QUERY}}
    }
    html {${IMAGE_QUERY}}
    contentCollection(limit: ${contentLimit}, skip: ${contentSkip}) {
        items {
            __typename
            ... on Product {${getProductCardQuery()}}
            ... on Zone {
                sys { id }
                id
                slug
                title
                subtitle
                description
                season{ title slug }
                category{id title slug }
                featuredBanner {${IMAGE_QUERY}}
                banner {${IMAGE_QUERY}}
                zoneLogo {${IMAGE_QUERY}}
                sponsorLogo {${IMAGE_QUERY}}
                imageBg {${IMAGE_QUERY}}
                schedule {${SCHEDULE_QUERY}}
                location{${LOCATION_QUERY}}
                button { label link }
                startingPrice
                currencyCode
                newZone
            }
            ... on WebCard {${CARD_QUERY}}
            ... on Category { sys { id } id slug title icon {${IMAGE_QUERY}} background {${IMAGE_QUERY}} isNew }
            ... on Tag { sys { id } id slug title icon {${IMAGE_QUERY}} background {${IMAGE_QUERY}} isNew }
            ... on SocialBanner {
                sys { id }
                id
                title
                logoImage {${IMAGE_QUERY}}
                socialLinks {
                    id
                    title
                    iconLinksCollection(limit: 6) {
                        items {${LINK_QUERY}}
                    }
                }
            }
            ... on SponsorList {
                sys { id }
                id
                title
                sponsorsCollection(limit: 12) {
                    items {
                        id
                        title
                        logo {${IMAGE_QUERY}}
                        link
                    }
                }
            }
        }
    }
`;

export {
  getWebSectionQuery
};
//# sourceMappingURL=chunk-ZYT27J35.mjs.map